import { defineComponent as _defineComponent } from 'vue'
import virtualList from '@/components/materialTable'
import { verifyInputNumber } from '@/util/commonFuncs'
import { specialPlankList } from '@/views/materialsList/config/tableConfig'
import { nanoid } from 'nanoid'
import { computed, reactive, ref, watch } from 'vue'

type Options = { label: string; value: string }
interface IProps {
  data: {
    color: string
    height: number
    isPicked: boolean
    matCode: string
    thick: number
    width: number
    partUniqueId?: string
  }[]
  matCodeList: Options[]
  colorList: (Options & { children?: Options[] })[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-special-plank-table',
  props: {
    data: null,
    matCodeList: null,
    colorList: null
  },
  setup(__props: any) {

const props = __props as {
  data: {
    color: string
    height: number
    isPicked: boolean
    matCode: string
    thick: number
    width: number
    partUniqueId?: string
  }[]
  matCodeList: Options[]
  colorList: (Options & { children?: Options[] })[]
}


// 状态
const state = reactive({
  // 当前行
  current: null as unknown as IProps['data'][0],
  // 颜色列表
  colorList: props.colorList,
  // 对比数据
  compareData: JSON.parse(JSON.stringify(props.data)),
})
// 厚度默认列表
const thickList = ref([
  { label: 5, value: 5 },
  { label: 9, value: 9 },
  { label: 12, value: 12 },
  { label: 18, value: 18 },
  { label: 25, value: 25 },
  { label: 30, value: 30 },
  { label: 50, value: 50 },
])

const tableData = computed(() =>
  props.data?.map((it) => {
    it.partUniqueId = nanoid()
    return it
  })
)
watch(
  () => props.colorList,
  () => {
    state.colorList = props.colorList
  },
  {
    deep: true,
  }
)

// 第三方值判断
const isThinkerxMaterial = computed(
  () => !window.sessionStorage.getItem('thinkerx_material')
)

/**
 * 处理事件
 */
// 保存当前行的数据
function onCellClick(data: IProps['data'][0]) {
  state.current = data
}
// 切换高光板
function changePlankType(value: string, { part }: any) {
  let { matCode } = part
  // 确定新的材质
  if (matCode.startsWith('高光_') && !value) {
    matCode = matCode.replace('高光_', '')
  } else if (!matCode.startsWith('高光_') && value) {
    matCode = '高光_' + matCode
  } else {
    return
  }
  part.matCode = matCode
}
// 控制数据的输入规则
function onInputChange({ part, field }: any) {
  const keys = ['thick', 'width', 'height', 'thick']
  if (!keys.includes(field)) return
  const value = part[field]
  verifyInputNumber(value, part, [field], '8-2')
}
// 颜色输入框输入事件
function handleInputChange(e: any) {
  const element = e.target as HTMLInputElement
  // 存在一个临时颜色组，用于记录用户的输入
  let target = state.colorList.find((it) => it.label === '临时颜色组')
  if (target) {
    if (!target.children?.find((it) => it.label === element.value)) {
      target.children?.push({ label: element.value, value: element.value })
    }
  } else {
    target = {
      label: '临时颜色组',
      value: '临时颜色组',
      children: [{ label: element.value, value: element.value }],
    }
    state.colorList.push(target)
  }
  // 如当前输入是在临时创建的颜色组内，则将点击的当前行数据color设置为输入的值
  if (target?.children?.find((it) => it.label === element.value)) {
    state.current.color = element.value
  }
}
// 获取级联选择器的元素
function onCascaderFocus(e: MouseEvent) {
  const target = e.target as HTMLInputElement & { WebUniqueId: string }
  // 每次添加一个ID，存在ID则不继续添加事件
  if (!target.WebUniqueId) {
    target.addEventListener('input', handleInputChange)
  }
  target.WebUniqueId = nanoid()
}

/**
 * 数据操作
 */
function handleDelPlank(part: any) {}

return { __sfc: true,props, state, thickList, tableData, isThinkerxMaterial, onCellClick, changePlankType, onInputChange, handleInputChange, onCascaderFocus, handleDelPlank, virtualList, specialPlankList }
}

})